import { render, staticRenderFns } from "./contest-tag.vue?vue&type=template&id=1f746bd2&scoped=true"
import script from "./contest-tag.vue?vue&type=script&lang=js"
export * from "./contest-tag.vue?vue&type=script&lang=js"
import style0 from "./contest-tag.vue?vue&type=style&index=0&id=1f746bd2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f746bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f746bd2')) {
      api.createRecord('1f746bd2', component.options)
    } else {
      api.reload('1f746bd2', component.options)
    }
    module.hot.accept("./contest-tag.vue?vue&type=template&id=1f746bd2&scoped=true", function () {
      api.rerender('1f746bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/contest-tag.vue"
export default component.exports